<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCard class="p-4">
          <CCardBody>
            <CForm @submit.prevent="login">
              <h3>ĐĂNG NHẬP</h3>
              <p class="text-muted">Đăng nhập vào tài khoản</p>
              <CInput
                v-model="username" required
                placeholder="Tài khoản"
                autocomplete="username email">
                <template #prepend-content>
                  <CIcon name="cil-user"/>
                </template>
              </CInput>
              <CInput
                v-model="password" required
                placeholder="Mật khẩu"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="curent-password">

                <template #prepend-content>
                  <CIcon name="cil-lock-locked"/>
                </template>

                <template #append>
                  <CButton
                    size="sm"
                    class="m-0"
                    color="outline-secondary"
                    @click="togglePasswdShow"
                  >
                    <CIcon :name="viewIcon" size="sm" class="m-0" color="info" />
                  </CButton>
                </template>
              </CInput>

              <CButton type="submit" color="info" shape="pill" style="width: 100%;">ĐĂNG NHẬP</CButton>

              <CRow style="margin-top: 10px">
              <CButton color="link" @click="resetPassword">Quên mật khẩu?</CButton>
              <CButton color="link" @click="register">Chưa có tài khoản?</CButton>
              </CRow>

            </CForm>
            <CRow v-if="errMsg" class="mt-2 mb-0 p-0 justify-content-center">
              <p style="color:red; word-wrap: break-word; white-space: normal;">{{errMsg}}</p>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      errMsg: '',
      showPassword: false,
    };
  },
  computed: {
    viewIcon() {
      return this.showPassword ? 'cil-lock-unlocked' : 'cil-lock-locked'
    }
  },
  methods: {
    login() {
      this.errMsg = ''
      this.$request.post('/login', {
          username: this.username,
          password: this.password,
      }).then(res => {
        // console.log(res.data);
        if (res.data.status === 'success') {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('username', res.data.username);
          localStorage.setItem('role', res.data.role);
          if(res.data.role === "monitor") {
            this.$router.push({path: '/device'});  // Redirect to specific path
          } else if (res.data.role === "customer") {
            this.$router.push({path: '/customer'});  // Redirect to specific path
          } else {
            this.$router.push({path: '/'});  // Redirect to home page after login
          }
        } else {
          this.errMsg = res.data.status
        }
      }).catch((error) => {
        if (error.response) {
          // console.log('HTTP Status Code:', error.response.status, error.response.data);
          if (error.response.status === 401) {
            this.errMsg = "Tài khoản hoặc mật khẩu không hợp lệ"
          }
        } else {
          this.errMsg = "Lỗi kết nối, vui lòng liên hệ quản trị viên"
        }
      });
    },
    register() {
      this.$router.push('/register');
    },
    resetPassword() {
      this.$router.push('/forget');
    },
    togglePasswdShow() {
      if(this.showPassword) {
        // console.log('show password');
        this.showPassword = false
      } else {
        // console.log('hide password');
        this.showPassword = true
      }
    },
  }
}
</script>

<style scoped>
.show-cursor {
  cursor: pointer;
}
</style>


